import _sfc_main from './src/icon.vue2.mjs';
export { iconProps } from './src/icon.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElIcon = withInstall(_sfc_main);

export { ElIcon, ElIcon as default };
//# sourceMappingURL=index.mjs.map
